import { useLocation } from "react-router-dom";

import { RoleGate } from "@/components/layout/RoleGate";
import { adminNavItems } from "@/components/layout/Sidebar";
import { usePermissions } from "@/hooks/usePermissions";

interface AdminGuardProps {
  children: React.ReactNode;
}

/** The section a refused `/admin` address was for, named as the sidebar names it. */
function sectionTitle(pathname: string): string {
  const match = adminNavItems
    .filter(
      (item) =>
        item.href !== "/admin" &&
        (pathname === item.href || pathname.startsWith(`${item.href}/`)),
    )
    .sort((a, b) => b.href.length - a.href.length)[0];
  return match?.name ?? "Administration";
}

/**
 * Administration is for administrators. Anyone else who opens an `/admin`
 * address, typed, bookmarked or shared, is told so in place, with a way back,
 * rather than bounced to the dashboard with no word of why, which read as the
 * app losing their click. Nothing behind the gate mounts, so no request goes.
 */
export function AdminGuard({ children }: AdminGuardProps) {
  const { isAdmin } = usePermissions();
  const { pathname } = useLocation();

  if (!isAdmin) {
    return (
      <RoleGate title={sectionTitle(pathname)} requirement="administrators" />
    );
  }

  return <>{children}</>;
}
